module.exports = __webpack_public_path__ + "static/media/alarm.0588db18.svg";